import { api } from "./api/apiSlice";

export const sslPaymentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createSslPayment: builder.mutation<any, any>({
      query: (data) => ({
        url: `ssl/payment/create`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ssl"],
    }),
    multipleSslPayment: builder.mutation<any, any>({
      query: (data) => ({
        url: `ssl/payment/create/all`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ssl"],
    }),
  }),
});

export const { useCreateSslPaymentMutation,useMultipleSslPaymentMutation } = sslPaymentApi;
